/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupsfieldtitle2Inputs */

const en_groupsfieldtitle2 = /** @type {(inputs: Groupsfieldtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group name`)
};

const de_groupsfieldtitle2 = /** @type {(inputs: Groupsfieldtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name der Gruppe`)
};

/**
* | output |
* | --- |
* | "Group name" |
*
* @param {Groupsfieldtitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupsfieldtitle2 = /** @type {((inputs?: Groupsfieldtitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupsfieldtitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupsfieldtitle2(inputs)
	return de_groupsfieldtitle2(inputs)
});
export { groupsfieldtitle2 as "groupsFieldTitle" }